import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import get from 'lodash/get';
import { handleSubmissionErrors } from '../../../../utils/errors'
import Layout from '../../../../layout';
import promoFlags from '../../../../utils/promo-flag-accom-options';
import modalTitles from '../../../../utils/modal-title-options';
import ctaTitleOptions from '../../../../utils/cta-title-options-accommodations';
import * as propertyActions from '../../../../actions/properties';
import * as accommodationActions from '../../../../actions/accommodations';
import * as sidebarActions from '../../../../actions/sidebar';
import * as imageActions from '../../../../actions/images';
import HotelAccommodationForm from '../../../../components/HotelAccommodationForm';
import FormNavigator from '../../../../components/FormNavigator';

const propTypes = {
  hotel: PropTypes.object.isRequired,
  miscAccom: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  images: PropTypes.array.isRequired,
  updateAccommodation: PropTypes.func.isRequired,
  fetchProperty: PropTypes.func.isRequired,
  fetchAccommodation: PropTypes.func.isRequired,
  updateSidebar: PropTypes.func.isRequired,
  setCurrentImage: PropTypes.func.isRequired,
  setActiveImage: PropTypes.func.isRequired
};

const sections = [
  { id: 'title', title: 'Title & Content' },
  { id: 'date', title: 'Date & Time' },
  { id: 'image', title: 'Set an Image' },
  { id: 'cta', title: 'CTA (Call to Action)' },
  { id: 'promo', title: 'Promo Flag' },
  { id: 'preview', title: 'Preview + Publish' },
];

const MiscAccomEdit = ({
  hotel,
  miscAccom,
  images,
  isLoading,
  match: {
    params: { hotelid, id }
  },
  history: { push },
  updateAccommodation,
  fetchProperty,
  fetchAccommodation,
  updateSidebar,
  setCurrentImage,
  setActiveImage
}) => {
  useEffect(() => {
    fetchProperty(hotelid).then(property => {
      updateSidebar({ titles: { Hotel: property.name } });
    });
    fetchAccommodation(hotelid, id);
    return () => {};
  }, []);

  useEffect(() => {
    // eslint-disable-next-line no-shadow
    const images = get(miscAccom, 'images', []);
    get(miscAccom, 'images', []).forEach(image => {
      setCurrentImage('hotel-accommodations-image', image);
    });

    // FIXME this is not ideal. But the original setup was using a 1 index vs a
    // 0 index and state management for what is considered active is also
    // incorrect. This will fix for now, but concerns are spread out all over
    // the place.
    if (images.length) {
      const idx = images.findIndex(v => v.sortIndex === 0);
      setActiveImage('hotel-accommodations-image', idx + 1);
    }
    return () => {};
  }, [miscAccom]);

  const handleSubmit = data => {
    const update = {
      ...data,
      startsOn: data.startsOn?.toJSON(),
      endsOn: data.endsOn ? data.endsOn.toJSON() : data.endsOn,
      // images are always an array, which is always ordered, iterate and set
      // the sort_index based on that order
      images: images.map(({ assetId, alt, videoUrl }, i) => ({
        assetId,
        alt,
        videoUrl,
        sort_index: i
      })),
      modal1Title:
        // eslint-disable-next-line no-nested-ternary
        data.modal1Title === 'None'
          ? null
          : data.modal1Title === 'Other'
          ? data.modal1TitleOther
          : data.modal1Title,
      modal2Title:
        // eslint-disable-next-line no-nested-ternary
        data.modal2Title === 'None'
          ? null
          : data.modal2Title === 'Other'
          ? data.modal2TitleOther
          : data.modal2Title,
      cta: Object.assign(
        data.cta,
        data.cta.type === 'Other' && { type: data.cta.typeInput }
      ),
      promo_flag:
        // eslint-disable-next-line no-nested-ternary
        data.promoFlag === 'Other' ? data.promoFlagOther : data.promoFlag
    };
    return updateAccommodation(hotelid, id, update)
      .then(() => push(`/hotels/${hotelid}/accommodations/miscs`))
      .catch(e => {
        handleSubmissionErrors(e)
      });
  };
  return (
    <Layout metaTitle="Edit Misc Accommodation">
      {isLoading ? (
        <div>Loading ...</div>
      ) : (
        <div className="w-full max-w-3xl">
          <Link
            to={`/hotels/${hotelid}/accommodations/miscs`}
            className="mb-8 inline-block text-sm text-grey-dark hover:text-grey-darkest no-underline"
          >
            &lt; Back to Misc Accommodations
          </Link>
          <h1 className="mb-6">Edit Misc Accommodation</h1>
          <div className="mb-16">
            Use this page to edit {miscAccom.title} Misc Accommodation on{' '}
            {hotel.name}.
          </div>
          <HotelAccommodationForm
            id="edit-misc-accoms-form"
            category="Misc Accommodation"
            hotel={hotel}
            initialValues={{
              ...miscAccom,
              // eslint-disable-next-line no-nested-ternary
              modal1Title: !miscAccom.modal1Title
                ? 'None'
                : modalTitles.findIndex(
                    title => title.id === miscAccom.modal1Title
                  ) === -1
                ? 'Other'
                : miscAccom.modal1Title,
              modal1TitleOther:
                modalTitles.findIndex(
                  title => title.id === miscAccom.modal1Title
                ) === -1
                  ? miscAccom.modal1Title
                  : undefined,
              // eslint-disable-next-line no-nested-ternary
              modal2Title: !miscAccom.modal2Title
                ? 'None'
                : modalTitles.findIndex(
                    title => title.id === miscAccom.modal2Title
                  ) === -1
                ? 'Other'
                : miscAccom.modal2Title,
              modal2TitleOther:
                modalTitles.findIndex(
                  title => title.id === miscAccom.modal2Title
                ) === -1
                  ? miscAccom.modal2Title
                  : undefined,
              showmodal2: !!miscAccom.modal2Title,
              cta: miscAccom.cta && {
                ...miscAccom.cta,
                type:
                  ctaTitleOptions.findIndex(
                    title => title.id === get(miscAccom, 'cta.type')
                  ) === -1
                    ? 'Other'
                    : get(miscAccom, 'cta.type'),
                typeInput:
                  ctaTitleOptions.findIndex(
                    title => title.id === get(miscAccom, 'cta.type')
                  ) === -1
                    ? get(miscAccom, 'cta.type')
                    : undefined
              },
              startsOn: miscAccom.startsOn
                ? new Date(miscAccom.startsOn)
                : miscAccom.startsOn,
              endsOn: miscAccom.endsOn
                ? new Date(miscAccom.endsOn)
                : miscAccom.endsOn,
              // eslint-disable-next-line no-nested-ternary
              promoFlag: !miscAccom.promoFlag
                ? 'None'
                : promoFlags.findIndex(
                    title => title.id === miscAccom.promoFlag
                  ) === -1
                ? 'Other'
                : miscAccom.promoFlag,
              promoFlagOther:
                promoFlags.findIndex(
                  title => title.id === miscAccom.promoFlag
                ) === -1
                  ? miscAccom.promoFlag
                  : undefined
            }}
            onSubmit={handleSubmit}
            enableReinitialize
            keepDirtyOnReinitialize
          />
        </div>
      )}
      <FormNavigator
        id="edit-miscAccoms-navigator"
        sections={sections}
        className="hidden xl:block mt-32 pt-16"
      />
    </Layout>
  );
};

MiscAccomEdit.propTypes = propTypes;

export default connect(
  (state, props) => ({
    hotel: state.property.data,
    miscAccom: state.accommodation.data,
    images: get(state, 'images.hotel-accommodations-image.items', [])
      .filter(item => item.file)
      .map(item => ({
        assetId: item.file.id,
        alt: item.alt,
        videoUrl: item.videoUrl
      })),
    isLoading: state.property.isLoading || state.accommodation.isLoading
  }),
  {
    ...propertyActions,
    ...sidebarActions,
    ...accommodationActions,
    ...imageActions
  }
)(MiscAccomEdit);
